/**
 * "View as" (6 Oct): start and stop. Both reset every cached read, so nothing
 * of one identity is ever shown under the other.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { startViewAs, stopViewAs, type ViewAsInfo } from "@/lib/api";
import { logger } from "@/lib/logger";

/** View the app as a directory person (`items[].id` of the employee search). */
export function useStartViewAs() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (employeeId: string): Promise<ViewAsInfo> => {
      logger.debug("[view-as] start", employeeId);
      const { data } = await startViewAs({
        body: { employee_id: employeeId },
        throwOnError: true,
      });
      return data;
    },
    onSuccess: async () => {
      await queryClient.resetQueries();
    },
  });
}

/** Back to the admin's own view. */
export function useStopViewAs() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (): Promise<void> => {
      logger.debug("[view-as] stop");
      await stopViewAs({ throwOnError: true });
    },
    onSettled: async () => {
      await queryClient.resetQueries();
    },
  });
}
